import {
  CreateTimelineEntryRequest,
  UpdateTimelineEntryRequest,
  UpdateEnvironmentDetailsRequest,
  UpdateProjectDescriptionRequest,
  UpsertScreenshotsRequest,
} from "../../slices/projects/Types";

export const projectsSagaActionTypes = {
  callGetProjectsListSaga: "callGetProjectsListSaga",
  callGetProjectDetailsSaga: "callGetProjectDetailsSaga",
  callGetIntegrationDetailSaga: "callGetIntegrationDetailSaga",
  callCreateTimelineEntrySaga: "callCreateTimelineEntrySaga",
  callUpdateTimelineEntrySaga: "callUpdateTimelineEntrySaga",
  callUpdateEnvironmentDetailsSaga: "callUpdateEnvironmentDetailsSaga",
  callUpdateProjectDescriptionSaga: "callUpdateProjectDescriptionSaga",
  callGetUspDetailsSaga: "callGetUspDetailsSaga",
  callGetScreenshotsSaga: "callGetScreenshotsSaga",
  callUpsertScreenshotsSaga: "callUpsertScreenshotsSaga",
  callDeleteScreenshotSaga: "callDeleteScreenshotSaga",
};

export const INTEGRATION_SCREENSHOT_TYPE = "integration_screenshot";

export const getProjectsListSagaAction: (partnerID: number) => {
  type: string;
  partnerID: number;
} = (partnerID) => {
  return {
    type: projectsSagaActionTypes.callGetProjectsListSaga,
    partnerID: partnerID,
  };
};

export const getProjectDetailsSagaAction: (
  projectName: string,
  partnerId: number
) => {
  type: string;
  projectName: string;
  partnerId: number;
} = (projectName, partnerId) => {
  return {
    type: projectsSagaActionTypes.callGetProjectDetailsSaga,
    projectName: projectName,
    partnerId: partnerId,
  };
};

export const getIntegrationDetailSagaAction: (integrationId: number) => {
  type: string;
  integrationId: number;
} = (integrationId) => {
  return {
    type: projectsSagaActionTypes.callGetIntegrationDetailSaga,
    integrationId: integrationId,
  };
};

export const createTimelineEntrySagaAction: (
  integrationId: number,
  payload: CreateTimelineEntryRequest,
) => {
  type: string;
  integrationId: number;
  payload: CreateTimelineEntryRequest;
} = (integrationId, payload) => {
  return {
    type: projectsSagaActionTypes.callCreateTimelineEntrySaga,
    integrationId: integrationId,
    payload: payload,
  };
};

export const updateTimelineEntrySagaAction: (
  timelineEntryId: number,
  payload: UpdateTimelineEntryRequest,
) => {
  type: string;
  timelineEntryId: number;
  payload: UpdateTimelineEntryRequest;
} = (timelineEntryId, payload) => {
  return {
    type: projectsSagaActionTypes.callUpdateTimelineEntrySaga,
    timelineEntryId: timelineEntryId,
    payload: payload,
  };
};

export const updateEnvironmentDetailsSagaAction: (
  technology: string,
  integrationType: string,
  integrationId: number,
  payload: UpdateEnvironmentDetailsRequest,
  file?: File | null,
) => {
  type: string;
  technology: string;
  integrationType: string;
  integrationId: number;
  payload: UpdateEnvironmentDetailsRequest;
  file?: File | null;
} = (technology, integrationType, integrationId, payload, file) => {
  return {
    type: projectsSagaActionTypes.callUpdateEnvironmentDetailsSaga,
    technology: technology,
    integrationType: integrationType,
    integrationId: integrationId,
    payload: payload,
    file: file,
  };
};

export const updateProjectDescriptionSagaAction: (
  technologyId: number,
  payload: UpdateProjectDescriptionRequest,
  onSuccess?: () => void,
  onError?: (message: string) => void,
) => {
  type: string;
  technologyId: number;
  payload: UpdateProjectDescriptionRequest;
  onSuccess?: () => void;
  onError?: (message: string) => void;
} = (technologyId, payload, onSuccess, onError) => {
  return {
    type: projectsSagaActionTypes.callUpdateProjectDescriptionSaga,
    technologyId,
    payload,
    onSuccess,
    onError,
  };
};

export const getUspDetailsSagaAction: (
  technologyId: number,
  integrationTypeId: number,
  integrationId: number,
  documentationId: number,
) => {
  type: string;
  technologyId: number;
  integrationTypeId: number;
  integrationId: number;
  documentationId: number;
} = (technologyId, integrationTypeId, integrationId, documentationId) => {
  return {
    type: projectsSagaActionTypes.callGetUspDetailsSaga,
    technologyId,
    integrationTypeId,
    integrationId,
    documentationId
  };
};

export const getScreenshotsSagaAction: (
  integrationTypeId: number,
  screenshotType?: string,
) => {
  type: string;
  integrationTypeId: number;
  screenshotType: string;
} = (integrationTypeId, screenshotType = INTEGRATION_SCREENSHOT_TYPE) => {
  return {
    type: projectsSagaActionTypes.callGetScreenshotsSaga,
    integrationTypeId,
    screenshotType,
  };
};

export const upsertScreenshotsSagaAction: (
  payload: UpsertScreenshotsRequest,
  onSuccess?: () => void,
  onError?: (message: string) => void,
) => {
  type: string;
  payload: UpsertScreenshotsRequest;
  onSuccess?: () => void;
  onError?: (message: string) => void;
} = (payload, onSuccess, onError) => {
  return {
    type: projectsSagaActionTypes.callUpsertScreenshotsSaga,
    payload,
    onSuccess,
    onError,
  };
};

export const deleteScreenshotSagaAction: (
  mediaId: number,
  integrationTypeId: number,
  onSuccess?: () => void,
  onError?: (message: string) => void,
) => {
  type: string;
  mediaId: number;
  integrationTypeId: number;
  onSuccess?: () => void;
  onError?: (message: string) => void;
} = (mediaId, integrationTypeId, onSuccess, onError) => {
  return {
    type: projectsSagaActionTypes.callDeleteScreenshotSaga,
    mediaId,
    integrationTypeId,
    onSuccess,
    onError,
  };
};
